import React from 'react';
import { PhoneIcon, CalendarIcon } from 'lucide-react';
export function StickyMobileCTA() {
  return <div className="fixed bottom-0 left-0 w-full bg-white border-t border-gray-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] z-50 lg:hidden pb-safe" data-id="element-252">
      <div className="flex p-3 gap-3" data-id="element-253">
        <a href="tel:+12485902195" className="flex-1 flex items-center justify-center gap-2 bg-brand-gray-light border border-gray-200 text-brand-navy font-bold py-3 px-4 rounded-lg active:bg-gray-100 transition-colors" data-id="element-254">
          <PhoneIcon className="w-5 h-5" data-id="element-255" />
          Call
        </a>
        <a href="#consultation-form" className="flex-[2] flex items-center justify-center gap-2 bg-brand-teal text-white font-bold py-3 px-4 rounded-lg active:bg-brand-teal-dark transition-colors shadow-md shadow-brand-teal/20" data-id="element-256">
          <CalendarIcon className="w-5 h-5" data-id="element-257" />
          Request Consultation
        </a>
      </div>
    </div>;
}